// 0x20d80bf51034 => 20:d8:0b:f5:10:34
export const hexToMac = (hex = '') =>
  hex
    .substr(2) // get rid of the "0x" prefix
    .toString(16)
    .replace(/(\w{2})(?!$)/g, '$1:');
